import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { UserService } from 'app/modules/user/services/user.service';
import { User } from '@nousmedis/guard-types/dist/frontend';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FascicleService } from 'app/modules/catalog-cloud/services/fascicle.service';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from 'app/modules/user/services/lang.service';


@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent implements OnInit {
    timeout: any = null;

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    // viewFasicleEdition: boolean = false;

    user: User;

    //Variables for edit fascicle
    idCatalog: string = '';
    idFascicle: string = '';
    productFilter: any = '';
    gridLocked: boolean = true;
    viewEditFascicle: boolean = false;
    currentLang: string;


    constructor (public layoutService: LayoutService, public el: ElementRef,
        public userService: UserService,
        private router: Router,
        private fascicleService: FascicleService,
        private langService: LangService
    ) {
        this.user = userService.getCurrentUser();

    }
    ngOnInit(): void {
        this.currentLang = this.langService.getLang(this.user?.id);
        this.listenForEditFascicle();
    }

    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;


        }
    }


    changeCurrentLang(lang: string) {
        this.langService.setLang(this.user?.id, lang);
        this.currentLang = lang;
        location.reload();
    }

    listenForEditFascicle() {

        this.fascicleService.toolbarData$.subscribe((data: any) => {
            this.idCatalog = data.idCatalog;
            this.idFascicle = data.idFascicle;
            this.productFilter = data.filter;
            // console.log('toolbarData', data);
            if (this.idCatalog && this.idFascicle) {
                this.viewEditFascicle = true;
            }
            else {
                this.viewEditFascicle = false;
            }
        });
    }

    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => this.layoutService.state.sidebarActive = false, 300);
            }
        }
    }

    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
    }

}
